<template>
    <div class="container zx-fill-ticket-info" v-cloak>

        <div class="swipe-header">
            <div class="image-box">
                <van-swipe :autoplay="3000" class="swipe-box">
                    <van-swipe-item v-for="(image, index) in swipeArray" :key="index">
                        <van-image 
                            class="swipe-itme"
                            fit="cover"
                            :src="tokenImage(image)"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>

        <div class="body g-big-tree-bg">
            
            <!-- 预约信息 -->
            <ul class="body-rander-item ">
                <li class="row-box info-row info-title ">
                    <div class="inner-row f-s-b">
                        <div class="info-left">
                            <!-- <i class="iconhebei iconhuodong3 theme-color-font icon-size"></i> -->
                            <!-- <span>{{option.name}}  {{option.isCharge === 0 ? '(免费)':''}}</span> -->
                            <span>{{option.name}}</span>
                        </div>
                        <div class="info-right f-c ellipsis">
                            <span>剩余名额:</span>
                            <span class="g-yellow-color count g-b-500">{{option.surplusQuota > 0 ? option.surplusQuota : 0}}</span>
                        </div>
                    </div>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconshizhong g-yellow-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '活', '动' ,'时', '间' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{option._startTimeStr}} - {{option._endTimeStr}}</span>
                </li>
                <li class="row-box info-row f-c">
                    <i class="iconhebei iconwode1 g-violet-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '报', '名', '人', '数' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{option.count}}人</span>
                </li>
                <li class="row-box info-row f-c">
                    <i class="iconhebei iconnianling g-green-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '报', '名', '条', '件' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{ (option.minAge>0 && option.maxAge>0) ? `${option.minAge} - ${option.maxAge}岁`:`无年龄限制` }} </span>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconprice g-yellow-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '地', '址' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{option.address}}</span>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconrenshu g-violet-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '报', '名', '限', '制' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{option.limitCount > 0 ? `${option.limitCount}人`:'无人数限制'}}</span>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconprice g-yellow-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '费', '用' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{option.isCharge === 0 ? '免费': `${option.price}元`}}</span>
                </li>

                <li class="row-box info-row f-c">
                    <i class="iconhebei iconjifen g-violet-color"></i>
                    <span class="left-txt f-s-b">
                        <span v-for="(item, index) in [ '积', '分' ]" :key="index">{{item}}</span>
                    </span>
                    <span class="right-txt">: {{option.score > 0 ? option.score : 0}}分</span>
                </li>

            </ul>

            <ul class="body-rander-item"></ul>

            <ul class="body-container ">
                <li class="title">
                    <i class="iconhebei iconxiangqing theme-color-font"></i>
                    <span class="txt g-b-500">活动介绍</span>
                </li>
                <li class="item"  >
                    <div v-if="option.promptMessage" v-html="option.promptMessage"></div>
                    <div v-else>暂无活动介绍</div>                    
                    <!-- 科学小实验活动聿活动名称:给小动物送食物(摩擦起电)蚁材料准备:芆袅1、各种可以进行摩擦的物品螃2、将各种用海绵和胡萝卜、竹叶形状的纸屑放在...             -->
                </li>

            </ul>
        </div>

        <div class="foot f-c">
            <van-button 
                class="btn f-c" 
                block 
                type="info" 
                v-touch:tap="routerPage"
                :class="isShowBtn ? '':'gray-color'"
            >
                {{btnTxt}}
            </van-button>
        </div>

    </div>
</template>

<script>
    import { 
        getActivityDetailUrl, 
    } from '@ticketUrl';
    import util from '@util';
    import { 
        Field,
        Calendar,
        Popup,
        DatetimePicker,
        RadioGroup, 
        Radio,
        Cell, 
        CellGroup,

        Form, 
        Button,

        Swipe, 
        SwipeItem, 
    } from 'vant';
    import {
        tokenImage
    } from '@js/url.js';
    export default {
        data() {
            return {
                swipeArray: [
                    require('@image/home/342.png'),
                ],
                option:{},
                isShowBtn: false,
                btnTxt: '我要报名',
                activityId: '',
            }
        },
        created() {
            this.getActivityDetai();
        },
        methods: {
            tokenImage,
            getActivityDetai(){
                const {
                    activityId: id,
                } = this.$route.query;
                this.activityId = id;
                this.$http.get(getActivityDetailUrl,{ params: { id }})
                .then(res=>{
                    const {
                        data
                    } = res;
                    if(data.image){
                        this.swipeArray = [];
                        this.swipeArray.push(data.image);
                    }
                    data._startTimeStr = util.formatTime(new Date(data.startTime),'时分秒');
                    data._endTimeStr = util.formatTime(new Date(data.endTime),'时分秒');
                    if ( new Date().getTime() < data.applyEndTime === false) {
                        this.btnTxt = "已截止报名";
                    } else if( !(data.surplusQuota > 0) ) {
                        this.btnTxt = "名额已满";
                    } else if( data.status !== 1  ) {
                        this.btnTxt = "已过报名时间";
                    }
                    this.isShowBtn = (new Date().getTime() < data.applyEndTime) && (data.surplusQuota > 0) && (data.status === 1)
                    this.option = data;
                })
            },

            routerPage(){
                if(this.isShowBtn){
                    // this.$router.push({ name: 'fillActivityInfo', query:{ activityId: this.activityId } })
                    this.$router.push({ name: 'activityCalendar', query:{ activityId: this.activityId } })
                }
            },
        },      
        components:{
            [Field.name]: Field,
            [Calendar.name]: Calendar,
            [Popup.name]: Popup,
            [DatetimePicker.name]: DatetimePicker,
            [RadioGroup.name]: RadioGroup, 
            [Radio.name]: Radio,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,

            [Form.name]: Form,
            [Button.name]: Button,

            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 50px)" !important;
        // padding-bottom: 50px;
        .swipe-header{
            .swipe-itme{
                // width: 100%;
                height: 100%;
            }
            .image-box{
                height: 185px;
                .swipe-box{
                    height: 100%;
                }
            }
            .header-line{
                height:47px;
                background:linear-gradient(270deg,rgba(32,107,148,1) 0%,rgba(14,57,91,1) 100%);
            }
        }

        .body{
            margin-bottom: 10px;
            padding: 7px;
            .body-rander-item{
                background-color: #ffffff;
                overflow: hidden;
                border-radius:5px;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                margin-bottom: 7px;
                .row-box{
                    position: relative;
                    box-sizing: border-box;
                    height: 50px;
                    padding: 0 12px;
                    background-color: #ffffff;
                    &:last-child{
                        .item-row{
                            border: 0;
                        }
                    }
                    .item-row{
                        border-bottom: .5px solid #CBCBCB;
                        height: 100%;
                        background-color: transparent;
                        font-size: 14px;
                    }
                    .right-control{
                        color: #9599A2;
                        position: absolute;
                        top: 50%;
                        overflow: hidden;
                        transform: translateY(-50%);
                        left: 90px;
                        right: 12px;
                        .icon-size{
                            &::before{
                                font-weight: 500;
                            }
                        }
                    }
                    .number-control{
                        justify-content: flex-start;
                        .number-box{
                            margin: 0 10px;
                            display: inline-flex;
                            vertical-align: top;
                            width:65px;
                            height:22px;
                            box-sizing: border-box;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .number-icon-size{
                            &::before{
                                font-size: 20px;
                                font-weight: 500;
                            }
                        }
                    }
                }
                .info-row{
                    padding-top: 10px;
                    padding-bottom: 10px;
                    align-items: baseline;
                    height: auto;
                    justify-content: flex-start;
                    font-size: 12px;
                    color: #979899;
                    .left-txt{
                        margin-left: 12px;
                        width: 80px;
                        text-align-last: justify;
                        color: #61666C;
                        font-weight: 500;
                    }
                    .right-txt{
                        width: ~"calc(100% - 85px)";
                    }
                }
                .info-title{
                    padding-left: 0;
                    padding-right: 0;
                    margin: 0 12px;
                    border-bottom: .5px solid #CCCCCC;

                    align-items: baseline;
                    justify-content: space-between;
                    .inner-row{
                        align-items: baseline;
                    }
                    .info-left{
                        max-width: ~"calc(100% - 120px)";
                        font-size:16px;
                        font-weight:500;
                        color:rgba(67,68,70,1);
                        .icon-size{
                            margin-right: 5px;
                        }
                    }
                    .info-right{
                        display: block;
                        max-width: 130px;
                        color: #666666;
                        .count{
                            font-size: 17px;
                            margin-left: 3px;
                        }
                    }
                }
            }
            .body-container{
                position: relative;
                border-radius:5px;
                overflow: hidden;
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                background-size: 118px 142px;
                background-repeat: no-repeat;
                background-position: right 70%;
                background-image: url('../../lib/image/home/567.png');
                background-color:rgba(255,255,255,1);
                box-sizing: border-box;
                width: 100%;
                padding: 14px 12px;
                font-size: 12px;
                color: #565656;
                height: auto;
                &{
                    .item:last-child{
                        margin: 0;
                    }
                }
                .title{
                    color: #434446;
                    font-size: 15px;
                    margin-bottom: 14px;
                    .txt{
                        margin-left: 12px;
                    }
                }
                .small-title{
                    font-size: 14px;
                    color: #565656;
                }
                .body-iamge{
                    width: 100%;
                    margin: 10px 0;
                }
                .item{
                    color: #666666;
                    margin-bottom: 10px;
                }
                .time{
                    padding-left: 9px;
                    letter-spacing: 1px;
                }
            }
            .contacts-title-box{
                padding-left: 12px;
                height: 50px;
                font-size: 14px;
                color: #555555;
                // justify-content: flex-start;
                .icon-size{
                    margin-right: 5px;
                    &::before{  
                        // font-size: 22px;
                    }
                }
                .look-narrators{
                    border: 0;
                    padding: 3px 6px;
                    font-size: 15px;
                    color:rgba(255,255,255,1);
                    background:rgba(92,162,253,1);
                    border-radius:3px;
                }
            }
        }

        .foot{
            background-color: #f0f1f4;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 50px;
            .btn{
                border: 0;
                font-size: 15px;
                color:rgba(255,255,255,1);
                width:332px;
                height:50px;
                background:rgba(92,162,253,1);
                border-radius:12px;
            }
        }

        .language-box{
            box-sizing: border-box;
            padding: 50px;
            flex-direction: column;
            .language{
                width: 100%;
            }
            .language-row{
                width: 100%;
                height: 40px;
            }
        }
    }
</style>